import { mdiGenderMale, mdiGenderFemale, mdiDog, mdiCat } from "@mdi/js";
export default Object.freeze({
    DOG: {
        id: 1,
        description: 'Cachorro',
        shortDescription: 'Cão',
        icon: require("../../public/img/dog-icon.svg"),
        plural: 'Cães'

    },
    CAT: {
        id: 2,
        description: 'Gato',
        shortDescription: 'Gato',
        icon: require("../../public/img/cat-icon.svg"),
        plural: 'Gatos'
    },
    WORDS_CONNECTOR: ' e ',
    getAnimalIcon(id) {
        if (id == this.DOG.id) return this.DOG.icon;
        return this.CAT.icon;
    },
    getAnimalDescription(id) {
        if (id == this.DOG.id) return this.DOG.description;
        return this.CAT.description;
    },
    getAnimalShortDescription(id) {
        if (id == this.DOG.id) return this.DOG.shortDescription;
        return this.CAT.shortDescription;
    },
    getAnimalPlural(id) {
        if (id == this.DOG.id) return this.DOG.plural;
        else if (id == this.CAT.id) return this.CAT.plural;
        return this.DOG.plural + this.WORDS_CONNECTOR + this.CAT.plural;
    },
    getAllowedAnimals(animals) {
        let allowedAnimals = '';
        if (animals && animals.length) {
            allowedAnimals = this.getAnimalPlural(animals[0]);
            if (animals.length == 2) {
                allowedAnimals += this.WORDS_CONNECTOR + this.getAnimalPlural(animals[1]);
            }
        }
        return allowedAnimals;
    },
    getSexDescription(sex) {
        if (sex === 0) return 'Macho';
        else return 'Fêmea';
    },
    getSexIcon(sex) {
        if (sex === 0) return mdiGenderMale;
        else return mdiGenderFemale;
    },
    DOG_BREEDS_BRAZILIAN: [
        "Não informado",
        "Sem Raça Definida (SRD, Vira Lata)",
        'Afghan Hound',
        'Africanis',
        'Aidi',
        'Airedale Terrier',
        'Akbash',
        'Akita',
        'Aksaray Malaklisi',
        'Alano Espanhol',
        'Alapaha Blue Blood Bulldog',
        'Husky do Alasca',
        'Alaskan Klee Kai',
        'Malamute do Alasca',
        'Alopekis',
        'Alpine Dachsbracke',
        'Bulldog Americano',
        'American Bully',
        'Cocker Spaniel',
        'Coonhound Inglês',
        'Esquimó Americano',
        'Foxhound Americano',
        'Hairless Terrier',
        'Leopard Hound',
        'Pit Bull Terrier',
        'Staffordshire Terrier',
        "Cão d'água Americano",
        'Anglo-Français de Petite Vénerie',
        'Appenzeller Sennenhund',
        'Ariège Pointer',
        'Ariégeois',
        'Pila Argentino',
        'Armant',
        'Armenian Gampr',
        'Artois Hound',
        'Mastiff Assírio',
        'Australian Cattle Dog',
        'Kelpie Australiano',
        'Pastor Australiano',
        'Australian Stumpy Tail Cattle',
        'Terrier Australiano',
        'Austrian Black and Tan Hound',
        'Pinscher Austríaco',
        'Australian Silky Terrier',
        'Azawakh',
        'Bắc Hà',
        'Bakharwal',
        'Banjara Hound',
        'Bankhar',
        'Barak hound',
        'Barbado da Terceira',
        'Barbet',
        'Basenji',
        'Pastor Basco',
        'Basset Artésien Normand',
        'Basset Bleu de Gascogne',
        'Basset Fauve de Bretagne',
        'Basset Hound',
        'Bavarian Mountain Hound',
        'Beagle',
        'Beagle-Harrier',
        'Bearded Collie',
        'Beauceron',
        'Bedlington Terrier',
        'Pastor Belga',
        'Pastor Bergamasco',
        'Berger Picard',
        'Bernese Mountain',
        'Bichon Frisé',
        'Biewer Terrier',
        'Billy',
        'Black and Tan Coonhound',
        'Black and Tan Terrier',
        'Black Norwegian Elkhound',
        'Black Russian Terrier',
        'Black Mouth Cur',
        'Bloodhound',
        'Blue Lacy',
        'Blue Picardy Spaniel',
        'Bluetick Coonhound',
        'Boerboel',
        'Pastor-boêmio',
        'Bichon Bolonhês',
        'Border Collie',
        'Border Terrier',
        'Borzoi',
        'Boston Terrier',
        'Bouvier dos Ardennes',
        'Bouvier dos Flandres',
        'Boxer',
        'Boykin Spaniel',
        'Braco Italiano',
        "Braque d'Auvergne",
        'Braque du Bourbonnais',
        'Braque Français',
        'Braque Saint-Germain',
        'Terrier Brasileiro',
        'Briard',
        'Briquet de Provence',
        'Briquet Griffon Vendéen',
        'Brittany',
        'Broholmer',
        'Bruno Jura Hound',
        'Pastor de Bucovina',
        'Bulgarian Hound',
        'Bulgarian Scenthound',
        'Bull Arab',
        'Bull Terrier',
        'Bulldog',
        'Bullmastiff',
        'Bully Kutta',
        'Burgos Pointer',
        'Ca Mè Mallorquí',
        'Ca de Bou',
        'Ca Rater Mallorquí',
        'Cairn Terrier',
        'Calupoh',
        'Campeiro Bulldog',
        'Can de Chira',
        'Can de Palleiro',
        'Canaan',
        'Canadian Eskimo',
        'Cane Corso',
        'Cane di Oropa',
        'Cane Paratore',
        'Cantabrian Water',
        'Cão de Gado Transmontano',
        'Cardigan Welsh Corgi',
        'Carea Leonés',
        'Carolina',
        'Pastor  dos Cárpatos',
        'Castro Laboreiro',
        'Catahoula Leopard',
        'Pastor Catalão',
        'Pastor do Cáucaso',
        'Cavalier King Charles Spaniel',
        'Pastor da Ásia Central',
        'Fousek Tcheco',
        'Český strakatý pes',
        'Cesky Terrier',
        'Chesapeake Bay Retriever',
        'Chien Français Blanc et Noir',
        'Chien Français Blanc et Orange',
        'Chien Français Tricolore',
        'Chihuahua',
        'Terrier Chileno',
        'Cão de Crista Chinês',
        'Chinook',
        'Chippiparai',
        'Chongqing',
        'Chortai',
        'Chow Chow',
        'Chukotka sled dog',
        'Cimarrón Uruguayo',
        'Cirneco do Etna',
        'Clumber Spaniel',
        'Cão Fino colombiano',
        'Continental bulldog',
        'Corsican',
        'Coton de Tulear',
        'Galgo Farejador de Creta',
        'Pastor Croata',
        'Curly-coated Retriever',
        'Cão-lobo-checoslovaco',
        'Dachshund',
        'Dálmata',
        'Dandie Dinmont Terrier',
        'Spitz Dinamarquês',
        'Danish–Swedish',
        'Denmark Feist',
        'Dingo',
        'Dobermann',
        'Dogo Argentino',
        'Dogo Sardesco',
        'Dogue Brasileiro',
        'Dogue de Bordeaux',
        'Donggyeongi',
        'Drentse Patrijshond',
        'Drever',
        'Dunker',
        'Pastor Holândes',
        'Smoushond Holandês',
        'Laika da Sibéria Oriental',
        'Pastor da Europa Oriental',
        'Ecuadorian Hairless',
        'Cocker Spaniel Inglês',
        'Foxhound Inglês',
        'Mastiff Inglês',
        'Setter Inglês',
        'Pastor Inglês',
        'Springer Spaniel Inglês',
        'Toy Terrier Inglês',
        'Boiadeiro de Entlebuch',
        'Erbi Txakur',
        'Estonian Hound',
        'Cão da Serra da Estrela',
        'Eurasier',
        'Pastor de Faroese',
        'Spaniel de Campo',
        'Fila Brasileiro',
        'Hound Finlandês',
        'Lapphund Finlandês',
        'Spitz Finlandês',
        'Flat-coated Retriever',
        'Bulldog francês',
        'Spaniel francês',
        'Galgo Espanhol',
        'Gascon Saintongeois',
        'Gaucho sheepdog',
        'Pastor da Georgia',
        'Hound Alemão',
        'German Longhaired Pointer',
        'Pinscher Alemão',
        'German Roughhaired Pointer',
        'Pastor Alemão',
        'German Shorthaired Pointer',
        'Spaniel Alemão',
        'Spitz Alemão',
        'German Wirehaired Pointer',
        'Schnauzer Gigante',
        'Terrier Glen do Imaal',
        'Golden Retriever',
        'Cão Polonês',
        'Gordon Setter',
        'Grand Anglo-Français Blanc et Noir',
        'Grand Anglo-Français Blanc et Orange',
        'Grand Anglo-Français Tricolore',
        'Grand Basset Griffon Vendéen',
        'Grand Bleu de Gascogne',
        'Grand Griffon Vendéen',
        'Great Dane',
        'Greater Swiss Mountain',
        'Harehound Grego',
        'Pastor Grego',
        'Gronlandshund',
        'Greyhound',
        'Griffon Bleu de Gascogne',
        'Griffon Bruxellois',
        'Griffon Fauve de Bretagne',
        'Griffon de Nivernais',
        'Dogo Guatemalo',
        'Gull Dong',
        'Gull Terrier',
        'Hällefors Elkhound',
        'Halden Hound',
        'Hamiltonstövare',
        'Hanover Hound',
        'Harrier',
        'Havanese',
        'Pastor do Himalaia',
        'Hmong bobtail dog',
        'Hokkaido',
        'Hovawart',
        'Huntaway',
        'Hygen Hound',
        'Ibizan Hound',
        'Icelandic Sheepdog',
        'Cão Pária Indiano',
        'Spitz indiano',
        'Setter Irlandês vermelho e branco',
        'Setter Irlandês',
        'Terrier Irlandês',
        "Cão d'água Irlandês",
        'Irish Wolfhound',
        'Istrian Coarse-haired Hound',
        'Istrian Shorthaired Hound',
        'Greyhound Italiano',
        'Jack Russell Terrier',
        'Jagdterrier',
        'Jämthund',
        'Spaniel Japonês',
        'Spitz japonês',
        'Terrier Japonês',
        'Jeju',
        'Jonangi',
        'Kai Ken',
        'Kaikadi',
        'Kamchatka Sled',
        'Kangal Pastor',
        'Kanni',
        'Karakachan',
        'Karelian Bear',
        'Karelo-Finnish Laika',
        'Kars',
        'Karst Pastor',
        'Keeshond',
        'Kerry Beagle',
        'Kerry Blue Terrier',
        'Khala',
        'King Charles Spaniel',
        'King Pastor',
        'Kintamani',
        'Kishu',
        'Kokoni',
        'Kombai',
        'Komondor',
        'Kooikerhondje',
        'Koolie',
        'Jindo Coreano',
        'Kromfohrländer',
        'Kuchi',
        'Kunming',
        'Mastiff curdo',
        'Kuvasz',
        'Labrador Retriever',
        'Lagotto Romagnolo',
        'Lài',
        'Lakeland Terrier',
        'Lancashire Heeler',
        'Landseer',
        'Lapponian Herder',
        'Large Münsterländer',
        'Leonberger',
        'Greyhound da Sardenha',
        'Lhasa Apso',
        'Liangshan',
        'Cão Lituano',
        'Lobito Herreño',
        'Löwchen',
        'Lucas Terrier',
        'Lupo Italiano',
        'Mackenzie River husky',
        'Magyar Agár',
        'Mahratta Hound',
        'Pastor de Majorca',
        'Maltês',
        'Manchester Terrier',
        'Maneto',
        'Markiesje',
        'Pastor Maremmano-Abruzzese',
        'McNab',
        'Pastor Americano Miniatura',
        'Bull Terrier Miniatura',
        'Fox Terrier Miniatura',
        'Pinscher Miniatura',
        'Schnauzer Miniatura',
        'Molossos de Épiro',
        'Mongrel',
        'Montenegrin Mountain Hound',
        'Moscow Watchdog',
        'Cur Montanhês',
        'Mountain Feist',
        'Mudhol Hound',
        'Mudi',
        'Mastiff Napolitano',
        'Nenets Herding Laika',
        'New Zealand Heading',
        'Newfoundland',
        'Norfolk Terrier',
        'Norrbottenspets',
        'Inuit do Norte',
        'Buhund norueguês',
        'Elkhound norueguês',
        'Lundehund norueguês',
        'Norwich Terrier',
        'Nova Scotia Duck Tolling Retriever',
        'Old Danish Pointer',
        'Old English Sheepdog',
        'Olde English Bulldogge',
        'Otterhound',
        'Pachón Navarro',
        'Pampas Deerhound',
        'Papillon',
        'Parson Russell Terrier',
        'Pastor Garafiano',
        'Pastore della Lessinia e del Lagorai',
        'Patagonian Sheepdog',
        'Patterdale Terrier',
        'Pequinês',
        'Pembroke Welsh Corgi',
        'Perdigueiro Galego',
        'Perro Majorero',
        'Cão-pelado-peruano',
        'Petit Basset Griffon Vendéen',
        'Petit Bleu de Gascogne',
        'Phalène',
        'Pharaoh Hound',
        'Phu Quoc Ridgeback',
        'Spaniel da Picardia',
        'Plummer Terrier',
        'Plott Hound',
        'Podenco Andaluz',
        'Podenco Canario',
        'Podenco Valenciano',
        'Pointer',
        'Poitevin',
        'Greyhound Polonês',
        'Polish Hound',
        'Polish Lowland Sheepdog',
        'Zwergspitz',
        'Spaniel de Pont-Audemer',
        'Poodle',
        'Porcelaine',
        'Podengo português',
        'Pointer Português',
        'Cão da Serra de Aires',
        'Cão de água português',
        'Posavac Hound',
        'Pražský Krysařík',
        'Presa Canário',
        'Pudelpointer',
        'Pug',
        'Puli',
        'Pumi',
        'Pungsan',
        'Mastiff Pirinês',
        'Cão de montanha dos Pirenéus',
        'Pastor-dos-pirinéus-de-pelo-curto',
        'Rafeiro do Alentejo',
        'Rajapalayam',
        'Greyhound de Rampur',
        'Rastreador Brasileiro',
        'Rat Terrier',
        'Ratonero Bodeguero Andaluz',
        'Ratonero Murciano',
        'Redbone Coonhound',
        'Rhodesian Ridgeback',
        'Rize Koyun',
        'Pastor Miorítico Romeno',
        'Rottweiler',
        'Rough Collie',
        'Spaniel russo',
        'Russkiy Toy',
        'Laika russo europeu',
        'Ryukyu',
        'Saarloos wolfdog',
        'Sabujo Espanhol',
        'Cão de Fila de São Miguel',
        'Saint-Usuge Spaniel',
        'Sakhalin Husky',
        'Saluki',
        'Samoieda',
        'Sapsali',
        'Sarabi',
        'Pastor da Sardenha',
        'Šarplaninac',
        'Schapendoes',
        'Schillerstövare',
        'Schipperke',
        'Schweizer Laufhund',
        'Schweizerischer Niederlaufhund',
        'Deerhound escocês',
        'Terrier escocês',
        'Sealyham Terrier',
        "Segugio dell'Appennino",
        'Segugio Italiano',
        'Segugio Maremmano',
        'Hound Sérvio',
        'Hound Sérvio Tricolor',
        'Buldogue Serrano',
        'Shar Pei',
        'Shetland Sheepdog',
        'Shiba Inu',
        'Shih Tzu',
        'Shikoku',
        'Pastor Shiloh',
        'Husky Siberiano',
        'Silken Windhound',
        'Sinhala Hound',
        'Skye Terrier',
        'Sloughi',
        'Slovak Rough-haired Pointer',
        'Slovak Cuvac',
        'Slovenský kopov',
        'Smaland Hound',
        'Pequeno Münsterländer',
        'Smithfield',
        'Smooth Collie',
        'Fox terrier de pelo liso',
        'Soft-coated Wheaten Terrier',
        'Pastor-da-rússia-meridional',
        'Mastiff Espanhol',
        "Cão d'água espanhol",
        'Spino degli Iblei',
        'Spinone Italiano',
        'Sporting Lucas Terrier',
        'São Bernardo',
        'Stabyhoun',
        'Staffordshire Bull Terrier',
        'Schnauzer Padrão',
        'Stephens Stock',
        'Styrian Coarse-haired Hound',
        'Spaniel de Sussex',
        'Lapphund Sueco',
        'Swedish Vallhund',
        'Taigan',
        'Cão de Taiwan',
        'Tamaskan',
        'Tang',
        'Tarsus çatalburun',
        'Pastor-de-tatra',
        'Tazy',
        'Teddy Roosevelt Terrier',
        'Telomian',
        'Terrier de Tenterfield',
        'Thai Bangkaew',
        'Thai Ridgeback',
        'Kyi Apso Tibetano',
        'Mastiff Tibetano',
        'Spaniel Tibetano',
        'Terrier Tibetano',
        'Tonya Finosu',
        'Tornjak',
        'Tosa Inu',
        'Terrier Toy',
        'Manchester Terrier Toy',
        'Transylvanian Hound',
        'Treeing Cur',
        'Treeing Feist',
        'Treeing Tennessee Brindle',
        'Treeing Walker Coonhound',
        'Trigg Hound',
        'Hound Tiroleano',
        'Terrier Valenciano',
        'Vikhan',
        'Villano de Las Encartaciones',
        'Villanuco de Las Encartaciones',
        'Vizsla',
        'Volkosob',
        'Volpino Italiano',
        'Weimaraner',
        'Welsh Hound',
        'Welsh Sheepdog',
        'Welsh Springer Spaniel',
        'Welsh Terrier',
        'West Country Harrier',
        'West Highland White Terrier',
        'West Siberian Laika',
        'Westphalian Dachsbracke',
        'Wetterhoun',
        'Whippet',
        'Pastor Branco',
        'Pastor Branco Suíço',
        'Wire Fox Terrier',
        'Wirehaired Pointing Griffon',
        'Wirehaired Vizsla',
        'Xiasi',
        'Xoloitzcuintle',
        'Laika da Yakutia',
        'Yorkshire Terrier',
        'Zerdava',
        'Poodle Gigante',
        'Poodle Miniatura',
        'Galgo Afegão',
        'Mastim Turco', 'Mastim da Anatólia',
        'Bulldog Sangue Azul de Alapaha',
        'Basset Alpino',
        'Terrier Americano sem Pelo',
        'Boiadeiro de Appenzell',
        'Braco de Ariège',
        'Cão do Ariége',
        'Boiadeiro Australiano', 'Red Heeler', 'Blue Heeler',
        'Boiadeiro Australiano de Cauda Chata',
        'Fox Paulistinha',
        'Cão Fazendeiro da Dinamarca e Suécia',
        'Spaniel Perdigueiro de Drente',
        'Cão sem pelo do Equador',
        'Cão Finlandês Da Lapônia',
        'Gascão Saintongeois',
        'Ovelheiro Gaúcho',
        'Braco Alemão de Pelo Longo',
        'Braco alemão de pelo áspero',
        'Braco alemão de pelo curto',
        'Braco Alemão de Pelo duro', 'Pointer Alemão de Pelo duro',
        'Grande Anglo Francês branco e preto',
        'Grande Branco Anglo Francês e laranja',
        'Grande Tricolor Anglo Francês',
        'Grande Azul da Gasconha',
        'Grande griffon da Vendeia',
        'Dogue Alemão', 'Dogue Dinamarquês',
        'Grande Boiadeiro Suíço',
        'Cão da Groelândia',
        'Griffon azul da Gasconha',
        'Griffon de Bruxelas',
        'Griffon fulvo da Bretanha',
        'Bichon Havanês',
        'Cão Islandês De Pastoreio',
        'Lébrel Irlandês', 'Lebréu Irlandês',
        'Galgo Italiano', 'Lebréu Italiano',
        'Jack Russell',
        'Pastor Rei',
        'Coolie Australiano',
        'Pastor Finlandês Da Lapônia',
        'Grande Munsterlander',
        'Pastor Herreño',
        'Pequeno Cão leão',
        'Galgo Húngaro',
        'Cão de Guarda de Moscou',
        'Galgo Caravan',
        'Spitz de Rena',
        'Terra Nova', 'Terra-Nova',
        'Retriever da Nova Escócia',
        'Braco Dinamarquês', 'Pointer Dinarmaquês',
        'Sheepdog Inglês',
        'Veadeiro Pampeano', 'Veadeiro dos Pampas',
        'Pastor da Patagônia',
        'Kelb Tal Fenek', 'Faraó',
        'Galgo Polaco',
        'Braco Polonês',
        'Pomeranian', 'Spitz Alemão Anão', 'Lulu Da Pomerânia',
        'Porcelana',
        'Dogue canário',
        'Collie de Pelo Longo',
        'Mastim Persa', 'Mastim Iraniano',
        'Pastor Iugoslavo',
        'Piccolo Lepraiolo',
        'Pastor De Shetland',
        'Braco Eslovaco', 
        'Pointer Eslovaco',
        'Cuvac Eslovaco',
        'Sabujo Eslovaco',
        'Collie de Pelo Curto',
        'Cão de Aponte Frisão',
        'Staffbull',
        'Braco da Estíria de Pelo Duro',
        'Spitz dos Visigodos',
        'Quirguistão Taighany',
        'Catalburun', 'Pointer Turco',
        'Braco Da Transilvânia',
        'Braco tirolês',
        'Galês',
        'Pastor de Gales',
        'Springer Spaniel de Gales',
        'Laika da Sibéria Ocidental',
        'Basset Alemão da Vestfália',
        "Cão d'água Frisão",
        'Cão de Água Frisão',
        'Fox terrier de pelo duro',
        'Braco Húngaro de Pelo Duro',
        'Pelado-mexicano',
    ],
    CAT_BREEDS_BRAZILIAN: [
        "Não informado",
        "Sem Raça Definida (SRD, Vira Lata)",
        'Maine Coon',
        'British Shorthair',
        'Persa',
        'Ragdoll',
        'Birman',
        'Abissínio',
        'Siamês',
        'American Shorthair',
        'Bengal (Gato-de-bengala)',
        'Birmanês',
        'Sphynx',
        'Devon Rex',
        'Exótico | Exotic Shorthair',
        'Cornish Rex',
        'Scottish Fold',
        'American Curl',
        'Bobtail Americano',
        'Bobtail Japonês',
        'Bombay',
        'Russian Blue (Azul Russo)',
        'Ocicat',
        'Gato Egyptian Mau',
        'Balinês',
        'Chartreux',
    ]
});